import { Link } from "react-router-dom";
import { CalendarCheck2, Users, TrendingUp, ArrowRight, Sparkles, Package } from "lucide-react";
import { MementoLogo, SalonUpLogo } from "@/components/Brand";

const SALON_IMG = "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxoYWlyJTIwc2Fsb24lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODU1MDM5OTB8MA&ixlib=rb-4.1.0&q=85";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[color:var(--sp-bg)] relative">
      <div className="absolute inset-0 memento-soft-glow pointer-events-none" />

      <nav className="relative max-w-7xl mx-auto px-6 lg:px-10 py-6 flex items-center justify-between">
        <MementoLogo withTagline size="md" />
        <div className="flex items-center gap-3">
          <Link data-testid="nav-login-link" to="/login" className="sp-btn-ghost text-sm">Accedi</Link>
          <Link data-testid="nav-register-link" to="/register" className="sp-btn-primary text-sm">Prova gratis</Link>
        </div>
      </nav>

      <section className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-8 lg:pt-16 pb-24 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7 sp-anim">
          <span className="label-eyebrow">Il sistema · by Salon Up</span>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.02] tracking-tight text-[color:var(--sp-text)]">
            Il gestionale che manda avanti <br className="hidden sm:block" />
            <span className="text-gradient">il tuo salone</span>.
          </h1>
          <p className="mt-6 text-lg text-[color:var(--sp-text-secondary)] max-w-xl leading-relaxed">
            Memento è lo strumento operativo del metodo Salon Up. Agenda, clienti, fatturato, magazzino, contatti ADS e KPI. Un sistema, non un software.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <Link data-testid="hero-cta-register" to="/register" className="sp-btn-primary inline-flex items-center gap-2">
              Attiva il tuo Memento <ArrowRight className="h-4 w-4" />
            </Link>
            <Link data-testid="hero-cta-login" to="/login" className="sp-btn-ghost">Hai già accesso?</Link>
          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-2xl">
            {[
              { icon: CalendarCheck2, label: "Agenda" },
              { icon: Users, label: "CRM Clienti" },
              { icon: TrendingUp, label: "Incassi" },
              { icon: Package, label: "Magazzino" },
            ].map((f) => (
              <div key={f.label} className="sp-card sp-card-hover p-4">
                <f.icon className="h-5 w-5 text-[color:var(--sp-brand)]" />
                <div className="mt-3 font-display font-black text-sm tracking-tight">{f.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="sp-card overflow-hidden">
            <div className="aspect-[4/5] w-full relative">
              <img src={SALON_IMG} alt="Salon" className="w-full h-full object-cover" />
              <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(11,14,26,0.15) 0%, rgba(11,14,26,0.65) 100%)" }} />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <Sparkles className="h-5 w-5 mb-3" />
                <p className="font-display text-xl font-black leading-snug tracking-tight">
                  &ldquo;Un salone che funziona anche quando il titolare non c&apos;è.&rdquo;
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative border-t border-[color:var(--sp-border)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-wrap items-center justify-between gap-6">
          <div className="text-sm text-[color:var(--sp-text-secondary)]">
            &ldquo;Non insegniamo a lavorare di più. Insegniamo a costruire un&apos;azienda che lavori meglio.&rdquo;
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-[color:var(--sp-text-muted)] uppercase tracking-widest">Un prodotto</span>
            <SalonUpLogo className="h-8" />
          </div>
        </div>
      </section>
    </div>
  );
}
